// Mock data for VELOUVA - Maison du Rouge

export const PRODUCTS = [
  {
    id: 'd3835d29-878f-4659-8002-97b24ec65602',
    name: 'Velvet Rouge Matte',
    shade: 'Crimson Petal',
    category: 'matte',
    price: 38,
    image: 'https://images.pexels.com/photos/4889718/pexels-photo-4889718.jpeg',
    swatch: '#A6293A',
    description: "A deeply pigmented, weightless matte lipstick infused with rose oil. Twelve hours of comfortable, hydrated wear in a true cool red.",
    stock: 80,
  },
  {
    id: '5f8a91c2-6b3a-49e1-8c2d-1a8d4f6c2e91',
    name: 'Soft Coral Reverie',
    shade: 'Coral Whisper',
    category: 'satin',
    price: 36,
    image: 'https://images.pexels.com/photos/3373736/pexels-photo-3373736.jpeg',
    swatch: '#D27563',
    description: "A second-skin satin finish in a warm dusty coral. Cushioned, hydrating, and quietly radiant.",
    stock: 65,
  },
  {
    id: '16f5c416-cbc5-47dd-825f-e82c25dd762f',
    name: 'Honey Petal Sheer',
    shade: 'Honey Petal',
    category: 'sheer',
    price: 32,
    image: 'https://images.pexels.com/photos/3373737/pexels-photo-3373737.jpeg',
    swatch: '#C98D6B',
    description: "A featherlight tinted balm composed with raw honey and shea. A soft, sun-warmed beige-rose.",
    stock: 110,
  },
  {
    id: '8b2d4e91-3c5f-4a7b-9e1d-5c8f3a6b2d91',
    name: 'Brick Suede',
    shade: 'Brick Suede',
    category: 'matte',
    price: 40,
    image: 'https://images.unsplash.com/photo-1586495777744-4413f21062fa?auto=format&fit=crop&w=1200&q=85',
    swatch: '#8B3A2B',
    description: "A grounded brick red with a velvet matte finish. The lipstick we return to season after season.",
    stock: 42,
  },
  {
    id: '39752c2c-84e9-4ce0-b2d1-f09a21b0eb32',
    name: 'Naked Rose Tinted Balm',
    shade: 'Naked Rose',
    category: 'sheer',
    price: 28,
    image: 'https://images.pexels.com/photos/3373739/pexels-photo-3373739.jpeg',
    swatch: '#C58A85',
    description: "The barely-there rose. A tinted balm composed with squalane for the most natural flush.",
    stock: 95,
  },
  {
    id: 'a1c7e3d2-9b4f-4e8d-bc2a-7f3d9a1e6c52',
    name: 'Glass Lacquer Gloss',
    shade: 'Clear Glass',
    category: 'gloss',
    price: 30,
    image: 'https://images.pexels.com/photos/3373745/pexels-photo-3373745.jpeg',
    swatch: '#F2D9D5',
    description: "A mirror-finish gloss with cushioning hyaluronic acid. Non-sticky. Pure clarity.",
    stock: 120,
  },
  {
    id: '67eb97bc-7a86-4a54-a035-2503b4764357',
    name: 'Bare Cashmere',
    shade: 'Bare Cashmere',
    category: 'satin',
    price: 36,
    image: 'https://images.pexels.com/photos/2533266/pexels-photo-2533266.jpeg',
    swatch: '#B98876',
    description: "The perfect nude. A warm pinky-beige in a soft satin finish — second-skin and effortless.",
    stock: 70,
  },
  {
    id: 'e4f8c2a1-5d9b-4c3e-8f7a-2b5d6e9c1a73',
    name: 'Noir Boudoir',
    shade: 'Noir',
    category: 'matte',
    price: 42,
    image: 'https://images.unsplash.com/photo-1631214540242-3cd9c1f5db3a?auto=format&fit=crop&w=1200&q=85',
    swatch: '#1F1416',
    description: "A daring near-black plum. Composed for an unforgettable evening — the maison's most-requested matte.",
    stock: 18,
  },
  {
    id: 'b3d8f1a9-2c5e-4b7d-9a1c-6f8e3d2b5a91',
    name: 'Mauve Soir',
    shade: 'Mauve Soir',
    category: 'matte',
    price: 38,
    image: 'https://images.unsplash.com/photo-1599733589046-8d6dee6e7c70?auto=format&fit=crop&w=1200&q=85',
    swatch: '#8E5773',
    description: "A smoky mauve with cool undertones. The lipstick that reads as effortlessly modern.",
    stock: 55,
  },
  {
    id: 'c2e6b9d1-4a8f-4d5c-bc3e-9f1d8a2c6e35',
    name: 'Berry Crush Gloss',
    shade: 'Berry Crush',
    category: 'gloss',
    price: 32,
    image: 'https://images.unsplash.com/photo-1571781565036-d3f759be73e4?auto=format&fit=crop&w=1200&q=85',
    swatch: '#9C2548',
    description: "A juicy berry stain with cushion gloss finish. Plumping, glossy, deliciously pigmented.",
    stock: 88,
  },
  {
    id: 'f7a3d8c2-1b9e-4f6d-8a2c-5e3b7d9c1a48',
    name: 'Burgundy Velvet Liner',
    shade: 'Burgundy',
    category: 'matte',
    price: 26,
    image: 'https://images.unsplash.com/photo-1583241800698-9c2e0c8c8c4e?auto=format&fit=crop&w=1200&q=85',
    swatch: '#5D1F2A',
    description: "A precise burgundy lip pencil composed with vitamin E. Built for shaping, layering, and lasting.",
    stock: 60,
  },
  {
    id: 'd9b2c5f8-3a6e-4c1d-9b8a-2f5e7c3a6d12',
    name: 'Pink Champagne Sheer',
    shade: 'Pink Champagne',
    category: 'sheer',
    price: 30,
    image: 'https://images.unsplash.com/photo-1599733589046-8d6dee6e7c70?auto=format&fit=crop&w=1200&q=85',
    swatch: '#E6B8B5',
    description: "A celebratory pink with a faint shimmer veil. Sheer wear, full luxury.",
    stock: 75,
  },
];

export const FINISHES = [
  { key: 'matte', name: 'Matte', tagline: 'Velvet pigments. Twelve-hour comfort.', image: 'https://images.pexels.com/photos/4889718/pexels-photo-4889718.jpeg' },
  { key: 'satin', name: 'Satin', tagline: 'Soft, second-skin shine.', image: 'https://images.pexels.com/photos/3373736/pexels-photo-3373736.jpeg' },
  { key: 'sheer', name: 'Sheer', tagline: 'Tinted balms. Featherlight wear.', image: 'https://images.pexels.com/photos/3373737/pexels-photo-3373737.jpeg' },
  { key: 'gloss', name: 'Gloss', tagline: 'Mirror finish. Plumping cushion.', image: 'https://images.pexels.com/photos/3373745/pexels-photo-3373745.jpeg' },
];

export const HERO_IMAGE = 'https://images.unsplash.com/photo-1779399147716-a3ca1e519406?auto=format&fit=crop&w=1400&q=85';
export const STORY_IMAGE = 'https://images.unsplash.com/photo-1776262145095-39d46d047537?auto=format&fit=crop&w=1400&q=85';

export const QUIZ_STEPS = [
  {
    key: 'tone',
    eyebrow: "WE'LL START WITH THE CANVAS.",
    title: 'Your skin tone',
    options: [
      { value: 'fair', label: 'FAIR', color: '#F3D9C0' },
      { value: 'light', label: 'LIGHT', color: '#E0B596' },
      { value: 'medium', label: 'MEDIUM', color: '#BE8770' },
      { value: 'tan', label: 'TAN', color: '#8E5A3F' },
      { value: 'deep', label: 'DEEP', color: '#4A2A1D' },
    ],
  },
  {
    key: 'undertone',
    eyebrow: 'THE BACKDROP TO YOUR PIGMENT.',
    title: 'Your undertone',
    options: [
      { value: 'cool', label: 'COOL', color: '#D4A6B8' },
      { value: 'neutral', label: 'NEUTRAL', color: '#CBA48C' },
      { value: 'warm', label: 'WARM', color: '#D29F7A' },
      { value: 'olive', label: 'OLIVE', color: '#B5A175' },
    ],
  },
  {
    key: 'finish',
    eyebrow: 'THE FEEL OF THE COMPOSITION.',
    title: 'Your preferred finish',
    options: [
      { value: 'matte', label: 'MATTE', color: '#A6293A' },
      { value: 'satin', label: 'SATIN', color: '#B98876' },
      { value: 'sheer', label: 'SHEER', color: '#E6B8B5' },
      { value: 'gloss', label: 'GLOSS', color: '#F2D9D5' },
    ],
  },
  {
    key: 'mood',
    eyebrow: 'THE FINAL NOTE.',
    title: 'Your mood',
    options: [
      { value: 'classic', label: 'CLASSIC', color: '#7A2231' },
      { value: 'romantic', label: 'ROMANTIC', color: '#C58A85' },
      { value: 'bold', label: 'BOLD', color: '#1F1416' },
      { value: 'effortless', label: 'EFFORTLESS', color: '#B98876' },
    ],
  },
];
